import { useDispatch, useSelector } from "react-redux";
import { HeadingTitle } from "../ModalContainer";
import { Fragment, useCallback, useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
  CreateChallanActions,
  DeleteChallanActions,
  getChallanActions,
} from "../../../Actions/AuditActions";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import Loading from "../../Loading/Loading";
import DataTable from "../../DataTable/DataTable";
import axios from "axios";
import { BASEURI } from "../../../Middleware/axiosInstance";

const HEADER_ARR = ["Challan No", "Created At", "Modified At", "Actions"];

const AddChallan = ({ close, manufactureOrderId }) => {
  const dispatch = useDispatch();

  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  //   Save Challan State
  const { save_challan, loading } = useSelector((state) => state.SaveChallan);

  //   get Challan State
  const { getChallan, loading: challan_loading } = useSelector(
    (state) => state.get_Challan
  );

  const [challan_no, setChallan_no] = useState("");
  const [debouncedChallanNo, setDebouncedChallanNo] = useState("");

  const [data, setData] = useState([]); // Store API data
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedChallanNo(challan_no);
    }, 500); // 500ms delay before calling API

    return () => {
      clearTimeout(handler); // Cleanup previous timeout
    };
  }, [challan_no]);

  const fetchData = useCallback(
    async (challan) => {
      try {
        setLoader(true);
        const response = await axios.post(`${BASEURI}`, {
          service_name: "manufacture_order_challan_suggestion",
          token: token,
          challan_no: challan,
        });

        setData(response?.data?.data?.inventory_list);
        setLoader(false);
        // console.log("API Response:", response?.data?.data?.inventory_list);
      } catch (error) {
        console.error("API Error:", error);
        setLoader(false);
      }
    },
    [token]
  );

  useEffect(() => {
    if (debouncedChallanNo) {
      fetchData(debouncedChallanNo);
    } else {
      setData([]);
    }
  }, [debouncedChallanNo, fetchData]);

  const [isChallanCreated, setIsChallanCreated] = useState(false);

  const handleCreateChallan = useCallback(() => {
    if (!challan_no) {
      return toast.error("Challan No Is Required.");
    }
    setIsChallanCreated(true);
    dispatch(
      CreateChallanActions(
        "manufacture_order_challan_save",
        token,
        manufactureOrderId,
        challan_no
      )
    );
  }, [challan_no, dispatch, manufactureOrderId, token]);

  useEffect(() => {
    if (save_challan && save_challan?.status === 1 && isChallanCreated) {
      setIsChallanCreated(false);
      toast.success(save_challan?.msg);
      dispatch(
        getChallanActions(
          "manufacture_order_challan_get",
          token,
          manufactureOrderId
        )
      );
    }
    if (save_challan && save_challan?.status === 0 && isChallanCreated) {
      setIsChallanCreated(false);
      toast.error(save_challan?.msg);
    }
  }, [save_challan, isChallanCreated, dispatch, manufactureOrderId, token]);

  useEffect(() => {
    dispatch(
      getChallanActions(
        "manufacture_order_challan_get",
        token,
        manufactureOrderId
      )
    );
  }, [dispatch, manufactureOrderId, token]);

  // console.log("CHALLAN: ", getChallan);

  const [isDeleted, setIsDeleted] = useState(false);
  const [isActiveChallan, setIsActiveChallan] = useState(null);

  // Delete Challan State
  const { deleteChallan, loading: deleteChallan__loading } = useSelector(
    (state) => state.DeleteChallan
  );

  const handleDeleteChallan = useCallback(
    (index, challan_no) => {
      setIsActiveChallan(index);
      setIsDeleted(true);
      dispatch(
        DeleteChallanActions(
          "manufacture_order_challan_delete",
          token,
          manufactureOrderId,
          challan_no
        )
      );
    },
    [dispatch, token, manufactureOrderId]
  );

  useEffect(() => {
    if (deleteChallan && deleteChallan?.status === 1 && isDeleted) {
      toast.success(deleteChallan && deleteChallan?.msg);
      setIsDeleted(false);
      dispatch(
        getChallanActions(
          "manufacture_order_challan_get",
          token,
          manufactureOrderId
        )
      );
    }
    if (deleteChallan && deleteChallan?.status === 0 && isDeleted) {
      toast.error(deleteChallan && deleteChallan?.msg);
      setIsDeleted(false);
      dispatch(
        getChallanActions(
          "manufacture_order_challan_get",
          token,
          manufactureOrderId
        )
      );
    }
  }, [deleteChallan, isDeleted, dispatch, manufactureOrderId, token]);

  const handleSelect = (challan) => {
    setChallan_no(challan);
    setData([]);
  };

  return (
    <div>
      <HeadingTitle title={`Add Challan`} center={false} closeModal={close} />
      <div className="mtx-1x">
        {/* Create Challan */}
        <div className="input__add__challan">
          <label htmlFor="" className="label">
            Challan No
          </label>
          <br />
          <input
            type="text"
            value={challan_no}
            onChange={(e) => setChallan_no(e.target.value)}
            placeholder="Challan No"
          />{" "}
          <br />
          {loader ? (
            <Loading loading={loader} color={"#1c1c1c"} size={32} mt={true} />
          ) : null}
          {data && data.length > 0 && (
            <ul
              style={{
                // border: "1px solid #ccc",
                padding: "10px",
                listStyle: "none",
                height: "120px",
                overflowY: "auto",
              }}
            >
              {data.map((item, index) => (
                <li
                  key={index}
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                    fontFamily: "Poppins_Medium",
                    fontSize: "12px",
                  }}
                  onClick={() => handleSelect(item.challan_no)}
                >
                  <strong>{item.challan_no}</strong> - {item.invoice_no} -{" "}
                  {item.from_location} - {item.type}
                </li>
              ))}
            </ul>
          )}
          <div>
            <Button onClick={handleCreateChallan}>
              {loading ? (
                <Loading loading={loading} color={"white"} size={16} />
              ) : (
                "Create Challan"
              )}
            </Button>
          </div>
        </div>
        {/* Create Challan */}

        <div className="cutter__master__list__row">
          {/* Get Challan Table Component starts here */}
          <div className="table-wrapper-pagination mtx-5">
            <div className="table-container-pagination">
              {challan_loading ? (
                <Loading
                  loading={challan_loading}
                  color={"rgba(1, 18, 34, 1)"}
                  size={32}
                />
              ) : (
                <Fragment>
                  <DataTable
                    header={HEADER_ARR}
                    challan_data={getChallan && getChallan?.data}
                    handleDeleteChallan={handleDeleteChallan}
                    deleteChallan__loading={deleteChallan__loading}
                    isActiveChallan={isActiveChallan}
                  />
                </Fragment>
              )}
            </div>
          </div>
          {/* Get Challan Table Component ends here */}
        </div>
      </div>
    </div>
  );
};

export default AddChallan;
